import { getAvailableChannels, getAvailableVariants } from './get-demo-previews';

/**
 * Aplica lógica reactiva cuando cambia un campo del formulario.
 * Ajusta automáticamente otros campos para mantener combinaciones válidas.
 */
export const applyFieldLogic = (fieldKey: string, value: any, formData: any): Record<string, any> => {
  const updates: Record<string, any> = {};

  if (fieldKey === 'stage') {
    const newStage = value;
    const currentChannel = formData.adChannel;
    const currentVariant = formData.variant;
    const availableChannels = getAvailableChannels(newStage);

    // 1. Validar canal
    if (currentChannel && !availableChannels.includes(currentChannel)) {
      updates.adChannel = availableChannels[0];
    }

    // 2. Validar variant
    const finalChannel = updates.adChannel || currentChannel;

    if (finalChannel) {
      // Si hay canal: validar variant en ese canal específico
      const availableVariants = getAvailableVariants(newStage, finalChannel);
      if (!availableVariants.includes(currentVariant)) {
        updates.variant = availableVariants[0];
      }
    } else {
      // Si NO hay canal: validar que variant exista en AL MENOS UN canal
      const variantExistsInAnyChannel = availableChannels.some(channel =>
        getAvailableVariants(newStage, channel).includes(currentVariant)
      );

      if (!variantExistsInAnyChannel) {
        const firstChannel = availableChannels[0];
        updates.variant = getAvailableVariants(newStage, firstChannel)[0];
      }
    }
  }

  if (fieldKey === 'adChannel') {
    const newChannel = value;
    const currentStage = formData.stage;
    const currentVariant = formData.variant;

    // Validar que el variant actual exista en el nuevo canal
    const availableVariants = getAvailableVariants(currentStage, newChannel);
    if (!availableVariants.includes(currentVariant)) {
      updates.variant = availableVariants[0];
    }
  }

  return updates;
};
